<template>
  <v-app style="height: 100%; max-width: 450px"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <div class="d-flex justify-center pt-1 pb-2" style="background-color: #004056;">
      <v-img contain max-height="52px" src="@/assets/referra-store-pros-every-project-316x104.png" />
    </div>
    <v-main class="grey lighten-3" style="height: calc(100% - 76px);">
      <router-view />
    </v-main>
  </v-app>
</template>
<script>


export default {
  name: 'LoggedOutLayout',
}
</script>
